import React, { useEffect, useState } from 'react';
import FormInputWrapper from 'components/FormInputWrapper';
const Input = (props) => {
    const { label, placeholder, textAsIcon, onChange, type, defaultValue } = props;
    const [value, setValue] = useState('');
    useEffect(() => {
        onChange(value);
    }, [onChange, value]);
    useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue);
        }
    }, [defaultValue, setValue]);
    return (React.createElement(FormInputWrapper, { label: label, textAsIcon: textAsIcon },
        React.createElement("input", { placeholder: placeholder, type: type.toLocaleLowerCase(), onChange: (event) => setValue(event.target.value), min: type === 'NUMBER' ? 0 : undefined, value: value })));
};
export default Input;
